import wxuserApi from '@/api/wxuser'

const wxuser={
  namespaced:true,
  state:{
    data:[],
    pagination:{current:1,total:0,pageSize:10,showSizeChanger:true,showTotal:total=>`总计 ${total} 条`},
    loading:false,
    sorter:{},
  },
  mutations:{
    setData:(state,data)=>{
      state.data=data
    },
    setPagination:(state,pagination)=>{
      state.pagination=pagination
    },
    setLoading:(state,loading)=>{
      state.loading=loading
    },
    setSorter:(state,sorter)=>{
      state.sorter=sorter
    }
  },
  actions:{
    async GetAll({ commit,state },pagination){
      commit('setLoading',true)
      const page={
        skipCount:pagination.pageSize*(pagination.current-1),
        maxResultCount:pagination.pageSize,
        ...pagination
      }           
      if(state.sorter.field){
        if(state.sorter.order==='ascend'){
          page.sorting=state.sorter.field
        }else{
          page.sorting=state.sorter.field+' desc'
        }
      }
      try{
        const res=await wxuserApi.getAll(page)
        pagination.total=res.result.totalCount
        commit('setPagination',pagination)
        commit('setData',res.result.items)
      }finally {
        commit('setLoading',false)
      }
    }
  }
}
export default wxuser